// src/components/onboarding/OnboardingViewerEmptyState.js
import React from "react";
import { Lock } from "lucide-react";

const OnboardingViewerEmptyState = () => (
  <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
    <div className="bg-muted rounded-full p-4 mb-5">
      <Lock className="h-10 w-10 text-muted-foreground" strokeWidth={1.5} />
    </div>
    <h2 className="text-xl font-semibold text-foreground mb-2">
      This workspace isn't set up yet
    </h2>
    <p className="text-sm text-muted-foreground max-w-sm">
      Ask a workspace admin or owner to create the first agent before you can view
      tests and results.
    </p>
  </div>
);

export default OnboardingViewerEmptyState;
